/*
  Love'nSpa — engagement hors widget (collection + fiche).

  Un seul écouteur générique. Aucun composant n'a besoin de JavaScript pour
  être mesuré : on pose des attributs dans le Liquid, ce fichier fait le reste.

    data-lns-event="lns_faq_open"          nom de l'événement dataLayer
    data-lns-once                          n'émettre qu'une fois par page
    data-lns-p-question="Où se garer ?"    paramètre `question`
    data-lns-p-index="3"                   paramètre `index` (numérique si possible)

  Trois façons d'émettre :
   1. clic sur un élément [data-lns-event] (ou un de ses enfants) ;
   2. ouverture d'un <details data-lns-event> ;
   3. CustomEvent 'lns:track' sur document, pour les composants JS qui
      connaissent une valeur que le HTML ne connaît pas (index de photo,
      action sur la carte) : document.dispatchEvent(new CustomEvent('lns:track',
      { detail: { event: 'lns_map_interact', action: 'pin' } })).

  Photos : suivi automatique, sans attribut. Les vignettes du carrousel mobile
  (.carousel__item[data-index]) sont observées à l'écran ; la lightbox desktop
  émet 'lns:track' depuis product-gallery-puzzle. Un seul lns_photo_view par
  photo et par page, plus `all_seen: true` quand toutes ont été vues.

  Contexte : item_id, session_id, page_type sont relus dans l'entrée
  page_context déjà poussée par datalayer-context.liquid. Rien n'est recalculé.

  DEUX DESTINATIONS, DEUX USAGES (11/09/2026)
   - window.dataLayer → GTM → GA4 : acquisition, campagnes, Google Ads.
     Encaisse le volume sans broncher, mais agrégé, soumis au consentement et
     aux seuils de confidentialité — inexploitable pour un rapport par logement.
   - window.LNS_FUNNEL.track → funnel-ingest (Supabase) : ligne à ligne,
     first-party, joignable à hebergements et bookings. C'est la source des
     rapports servis aux hébergeurs et aux admins dans le portail Lovable.
  Le `session_id` est le même des deux côtés : on peut recoller à tout moment.

  Le thème n'appelle jamais gtag/fbq : il pousse dans dataLayer, GTM arbitre.
*/
(function () {
  'use strict';
  if (window.LNS_ENGAGE) return;

  // ---- Contexte de page (déjà dans dataLayer) --------------------------
  function contexte() {
    var dl = window.dataLayer || [];
    for (var i = dl.length - 1; i >= 0; i--) {
      if (dl[i] && dl[i].event === 'page_context') return dl[i];
    }
    return {};
  }

  // ---- Miroir vers funnel-ingest ---------------------------------------
  // Noms sans préfixe, alignés sur les event_type déjà en base
  // (fiche_view, widget_visible, date_selected, checkout_start...).
  // lns_photo_view n'est pas ici : il part par jalons, voir photoVue().
  var VERS_FUNNEL = {
    select_item: 'card_click',
    lns_map_interact: 'map_interact',
    lns_faq_open: 'faq_open',
    lns_description_expand: 'description_expand',
    lns_equipments_expand: 'equipments_expand'
  };

  function versFunnel(type, payload, options) {
    try {
      if (window.LNS_FUNNEL && typeof window.LNS_FUNNEL.track === 'function') {
        window.LNS_FUNNEL.track(type, payload, options);
      } else {
        // lovenspa-funnel.js pas encore chargé : il videra la file.
        window.LNS_FUNNEL_QUEUE = window.LNS_FUNNEL_QUEUE || [];
        window.LNS_FUNNEL_QUEUE.push([type, payload, options]);
      }
    } catch (e) { /* jamais bloquant */ }
  }

  var dejaEmis = {};

  function pousser(nom, params, uneFois) {
    if (!nom) return;
    var cle = nom + '|' + (uneFois || '');
    if (uneFois && dejaEmis[cle]) return;
    if (uneFois) dejaEmis[cle] = true;

    var ctx = contexte();
    var evt = { event: nom };
    ['session_id', 'page_type', 'item_id', 'collection_handle'].forEach(function (k) {
      if (ctx[k] != null) evt[k] = ctx[k];
    });
    for (var p in params) if (params[p] != null && params[p] !== '') evt[p] = params[p];

    try {
      window.dataLayer = window.dataLayer || [];
      if (evt.ecommerce) window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push(evt);
    } catch (e) { /* jamais bloquant */ }

    var typeFunnel = VERS_FUNNEL[nom];
    if (!typeFunnel) return;
    // `ecommerce` ne part pas : c'est un format GA4, illisible en SQL. Les
    // champs utiles (item_id, price, index) sont déjà à plat dans params.
    var charge = {};
    for (var q in evt) if (q !== 'event' && q !== 'ecommerce') charge[q] = evt[q];
    versFunnel(typeFunnel, charge, {});
  }

  // ---- Lecture des attributs data-lns-p-* ------------------------------
  function paramsDe(el) {
    var out = {};
    for (var i = 0; i < el.attributes.length; i++) {
      var a = el.attributes[i];
      if (a.name.indexOf('data-lns-p-') !== 0) continue;
      var k = a.name.slice(11).replace(/-/g, '_');
      var v = a.value;
      out[k] = v !== '' && !isNaN(v) ? Number(v) : v;
    }
    return out;
  }

  function emettreDepuis(el) {
    var nom = el.getAttribute('data-lns-event');
    var params = paramsDe(el);
    var uneFois = el.hasAttribute('data-lns-once') ? (params.question || params.item_id || '1') : '';

    // select_item : schéma e-commerce GA4, items[] construit depuis les attributs.
    if (nom === 'select_item') {
      // Mémorise la liste d'où part le clic. La fiche d'arrivée la relira pour
      // renseigner entry_list, et cette valeur survit aux filtres, à la
      // pagination et aux URL réécrites, ce que document.referrer ne fait pas.
      // Portée sessionStorage, comme session_id : rien de persistant.
      try {
        if (params.item_list_id) {
          window.sessionStorage.setItem('lns_entry_list', String(params.item_list_id));
        }
      } catch (e) { /* navigation privée : on se rabat sur le referrer */ }

      params.ecommerce = {
        item_list_id: params.item_list_id,
        item_list_name: params.item_list_name,
        items: [{
          item_id: params.item_id,
          item_name: params.item_name,
          price: params.price,
          index: params.index,
          item_list_id: params.item_list_id
        }]
      };
    }
    pousser(nom, params, uneFois);
  }

  // 1. Clic
  document.addEventListener('click', function (ev) {
    var el = ev.target.closest && ev.target.closest('[data-lns-event]');
    if (!el || el.tagName === 'DETAILS') return;
    emettreDepuis(el);
  }, true);

  // 2. <details> ouvert
  document.addEventListener('toggle', function (ev) {
    var el = ev.target;
    if (!el || el.tagName !== 'DETAILS' || !el.open || !el.hasAttribute('data-lns-event')) return;
    emettreDepuis(el);
  }, true);

  // 3. Composants JS
  document.addEventListener('lns:track', function (ev) {
    var d = (ev && ev.detail) || {};
    var nom = d.event;
    if (!nom) return;
    if (nom === 'lns_photo_view') { photoVue(d.index, d.source || 'lightbox'); return; }
    var params = {};
    for (var k in d) if (k !== 'event' && k !== 'once') params[k] = d[k];
    pousser(nom, params, d.once);
  });

  // ---- Photos --------------------------------------------------------------
  var photosVues = {};
  var photosTotal = 0;
  var toutesVuesEmis = false;
  var jalonsFaits = {};

  // GA4 reçoit chaque photo : c'est son métier, et la distribution complète y
  // est utile. funnel-ingest ne reçoit que des JALONS — une galerie de 30
  // photos parcourue par 1 000 visiteurs, c'est 30 000 lignes par jour pour
  // une information que quatre points résument. Le dernier jalon porte
  // seen_count et total : la profondeur médiane reste calculable en SQL.
  var JALONS = [1, 25, 50, 100];

  function photoVue(index, source) {
    index = Number(index);
    if (isNaN(index) || photosVues[index]) return;
    photosVues[index] = true;
    var nb = Object.keys(photosVues).length;
    var params = { index: index, total: photosTotal, seen_count: nb, source: source };
    if (photosTotal && nb >= photosTotal && !toutesVuesEmis) {
      toutesVuesEmis = true;
      params.all_seen = true;
    }
    pousser('lns_photo_view', params);

    if (!photosTotal) return;
    var pct = Math.round((nb / photosTotal) * 100);
    for (var i = 0; i < JALONS.length; i++) {
      var j = JALONS[i];
      if (pct < j || jalonsFaits[j]) continue;
      jalonsFaits[j] = true;
      versFunnel('photo_view', {
        palier_pct: j,
        seen_count: nb,
        total: photosTotal,
        source: source,
        all_seen: nb >= photosTotal
      }, {});
    }
  }

  function initPhotos() {
    var items = document.querySelectorAll('[data-carousel] .carousel__item[data-index]');
    photosTotal = items.length;
    if (!photosTotal) return;

    // Carrousel mobile : une vignette visible à 60 % pendant un instant = vue.
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) photoVue(e.target.getAttribute('data-index'), 'carousel');
        });
      }, { threshold: 0.6 });
      items.forEach(function (el) { io.observe(el); });
    }
  }

  // Lightbox desktop : product-gallery-puzzle émet lns:track { event: 'lns_photo_view', index }
  // — routé vers photoVue() par l'écouteur générique ci-dessus.

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPhotos);
  } else {
    initPhotos();
  }

  window.LNS_ENGAGE = { push: pousser };
})();
